import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainTimeseriesFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om een GLD-Aanvulling aan te leveren. De kolommen tijd, waarde en status
        kwaliteits controle zijn verplicht. Zorg ervoor dat u het format in het volgende template
        hanteert:
      </Text>
      <Button
        mb={4}
        variant="primary"
        onClick={() =>
          downloadFile("/files/gldTimeseriesExcelTemplate.xlsx", "gldTimeseriesExcelTemplate.xlsx")
        }
      >
        Download Excel-template
      </Button>
      <Button
        variant="primary"
        onClick={() =>
          downloadFile("/files/gldTimeseriesCSVTemplate.csv", "gldTimeseriesCSVTemplate.csv")
        }
      >
        Download CSV-template
      </Button>
    </>
  );
};
